<template>
  <section class="page-container">
    <!--工具条-->
    <div ref="toolbar" class="toolbar">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-input v-model="filters.userId" placeholder="用户ID"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="filters.couponId" placeholder="优惠券ID"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="list">查询</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="handleAdd">新增</el-button>
        </el-form-item> -->
      </el-form>
    </div>

    <!--列表-->
    <el-table
      ref="dataTable"
      v-loading="listLoading"
      :data="results"
      highlight-current-row
      stripe
      border
      :height="tableHeight"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="id" label="ID"></el-table-column>
      <el-table-column prop="userId" label="用户ID"></el-table-column>
      <el-table-column prop="userId" label="用户昵称">
        <template slot-scope="scope">
          {{ scope.row.user.nickname }}
        </template>
      </el-table-column>
      <el-table-column prop="userId" label="用户头像">
        <template slot-scope="scope">
          <avatar :user="scope.row.user" />
        </template>
      </el-table-column>
      <el-table-column prop="couponId" label="优惠券ID"></el-table-column>
      <el-table-column prop="couponId" label="优惠券名称">
        <template slot-scope="scope">
          {{ scope.row.coupon.name }}
        </template>
      </el-table-column>
      <el-table-column prop="couponId" label="优惠券金额">
        <template slot-scope="scope">
          {{ scope.row.coupon.amount }}
        </template>
      </el-table-column>
      <el-table-column prop="couponId" label="最低使用价格">
        <template slot-scope="scope">
          {{ scope.row.coupon.minPrice }}
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态"></el-table-column>
      <el-table-column prop="expireTime" label="过期时间"></el-table-column>
      <el-table-column prop="createTime" label="创建时间"></el-table-column>
      <el-table-column prop="updateTime" label="修改时间"></el-table-column>
      <!-- <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-button size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
        </template>
      </el-table-column> -->
    </el-table>

    <!-- 分页 -->
    <my-pagination
      ref="pagebar"
      :page="page"
      @current-change="handlePageChange"
      @size-change="handleLimitChange"
    />

    <!--新增界面-->
    <el-dialog title="新增" :visible.sync="addFormVisible" :close-on-click-modal="false">
      <el-form ref="addForm" :model="addForm" label-width="120px">
        <el-form-item label="用户ID">
          <el-input v-model="addForm.userId"></el-input>
        </el-form-item>
        <el-form-item label="优惠券ID">
          <el-input v-model="addForm.couponId"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-input v-model="addForm.status"></el-input>
        </el-form-item>
        <el-form-item label="过期时间">
          <el-input v-model="addForm.expireTime"></el-input>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-input v-model="addForm.createTime"></el-input>
        </el-form-item>
        <el-form-item label="修改时间">
          <el-input v-model="addForm.updateTime"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" :loading="addLoading" @click.native="addSubmit">提交</el-button>
      </div>
    </el-dialog>

    <!--编辑界面-->
    <el-dialog title="编辑" :visible.sync="editFormVisible" :close-on-click-modal="false">
      <el-form ref="editForm" :model="editForm" label-width="120px">
        <el-input v-model="editForm.id" type="hidden"></el-input>
        <el-form-item label="id">
          <el-input v-model="editForm.id"></el-input>
        </el-form-item>
        <el-form-item label="用户ID">
          <el-input v-model="editForm.userId"></el-input>
        </el-form-item>
        <el-form-item label="优惠券ID">
          <el-input v-model="editForm.couponId"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-input v-model="editForm.status"></el-input>
        </el-form-item>
        <el-form-item label="过期时间">
          <el-input v-model="editForm.expireTime"></el-input>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-input v-model="editForm.createTime"></el-input>
        </el-form-item>
        <el-form-item label="修改时间">
          <el-input v-model="editForm.updateTime"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" :loading="editLoading" @click.native="editSubmit">提交</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import MyPagination from "@/components/MyPagination";
import Avatar from "@/components/Avatar";
export default {
  name: "UserCoupon",
  components: { MyPagination, Avatar },
  data() {
    return {
      tableHeight: 700,
      results: [],
      listLoading: false,
      page: {},
      filters: {},
      selectedRows: [],

      addForm: {},
      addFormVisible: false,
      addLoading: false,

      editForm: {},
      editFormVisible: false,
      editLoading: false,
    };
  },
  mounted() {
    this.list();
  },
  methods: {
    async list() {
      this.listLoading = true;
      const params = Object.assign(this.filters, {
        page: this.page.page,
        limit: this.page.limit,
      });
      try {
        const data = await this.axios.form("mall:/api/admin/user-coupon/list", params);
        this.results = data.results;
        this.page = data.page;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      } finally {
        this.listLoading = false;
      }
    },
    handleAdd() {
      this.addForm = {};
      this.addFormVisible = true;
    },
    async addSubmit() {
      try {
        await this.axios.form("mall:/api/admin/user-coupon/create", this.addForm);
        this.$message({ message: "提交成功", type: "success" });
        this.addFormVisible = false;
        await this.list();
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      }
    },
    async handleEdit(index, row) {
      try {
        const data = await this.axios.get("mall:/api/admin/user-coupon/" + row.id);
        this.editForm = Object.assign({}, data);
        this.editFormVisible = true;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      }
    },
    async editSubmit() {
      try {
        await this.axios.form("mall:/api/admin/user-coupon/update", this.editForm);
        await this.list();
        this.editFormVisible = false;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      }
    },
    async handlePageChange(val) {
      this.page.page = val;
      await this.list();
    },
    async handleLimitChange(val) {
      this.page.limit = val;
      await this.list();
    },
    handleSelectionChange(val) {
      this.selectedRows = val;
    },
  },
};
</script>

<style lang="scss" scoped></style>
